<template>
	<div id="map-popup" style="height: 300px"></div>
</template>

<script>
import phonesSuccess from "@/assets/images/markers/phones_success.png";
import {MapFeatures} from "@/plugins/mapFeatures";

export default {
	props: {
		name: {
			type: String,
			required: true,
			default: "themap",
		},
		latitude: {
			type: Number,
			required: false,
			default: 4.686699,
		},
		longitude: {
			type: Number,
			required: false,
			default: -74.0837187,
		},
		zoom: {
			type: String,
			required: false,
			default: "12",
		},
		theme: {
			type: String,
			required: false,
			default: null,
		},
		streetview: {
			type: String,
			required: false,
			default: "false",
		},
		calledFrom: {
			type: String,
			requeride: false,
			default: "maps",
		},
		cartodbId: {
			type: Number,
			default: 0,
		},
		getCallbackClick: {
			type: Function,
			default: () => {},
		},
		getCoordinatesDrag: {
			type: Function,
			default: () => {},
		},
		changeCursorEnable: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			map: "",
			marker: null,
			options: {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0,
			},
			mapFeature: null,
		};
	},
	methods: {
		success(pos) {
			const crd = pos.coords;
			const position = {cy: this.latitude || +crd.latitude, cx: this.longitude || +crd.longitude};
			this.marker = this.mapFeature.addMarkerToMap(position, {
				icon: phonesSuccess,
				draggable: true,
				infoWindow: {
					content: `
						<div class='flex items-center mt-2'>
							<span class='text-ms'>${position.cy}, ${position.cx}</span>
						</div>	
					`,
				},
				onDragend: (coords) => {
					this.getCoordinatesDrag(coords);
				},
			});
			this.$emit("getInstanceMapEmit", {map: this.map, marker: this.marker});
		},
		error(err) {
			this.map.setCenter({lat: 4.686699, lng: -74.0837187});
			console.warn("ERROR(" + err.code + "): " + err.message);
		},
		async initMap() {
			this.map = await new google.maps.Map(document.getElementById("map-popup"), {
				center: {lat: this.latitude, lng: this.longitude},
				zoom: 8,
			});
			google.maps.event.addListener(this.map, "click", (event) => {
				this.getCallbackClick(event);
			});
			navigator.geolocation.getCurrentPosition(this.success, this.error, this.options);
			if (this.changeCursorEnable) {
				this.changeCursor("crosshair");
			}
			this.mapFeature = new MapFeatures(this.map);
		},
		/**
		 * change cursor options from different options
		 * * https://www.rubenalcaraz.es/pinakes/informatica/introduccion-google-maps-apiv3-mapoptions-y-el-contenedor-y-cursor/
		 * * https://itecnote.com/tecnote/google-maps-how-do-i-set-a-custom-image-for-the-mouse-cursor-in-a-google-map-api-v3-map/
		 */
		changeCursor(type = "pointer") {
			this.map.setOptions({draggableCursor: type});
		},
	},
	mounted() {
		this.initMap();
	},
};
</script>

<style scoped>
/** custom content for map */
.map-custom-container {
	margin-top: calc(100% - 102%);
	margin-left: -35px;
	margin-right: -35px;
	height: 88vh;
}

.street-vien-container {
	width: 100%;
	height: 40vh;
}

.customizer-btn-map-opc {
	position: fixed;
	top: 50%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.customizer-btn-map-clear {
	position: fixed;
	top: 45%;
	right: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-top-left-possition {
	position: fixed;
	top: 69px;
	left: 100px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	z-index: 50000;
}

.map-custom-container-calendar {
	height: 560px !important;
}

@media (min-width: 1400px) {
	.map-custom-container {
		margin-top: calc(100% - 102%);
		height: 93vh;
	}

	.street-vien-container {
		width: 100%;
		height: 60vh;
	}
}

@media (max-width: 992px) {
	.map-custom-container {
		margin-top: calc(100% - 109%);
		height: 89vh;
	}

	.street-vien-container {
		width: 100%;
		height: 40vh;
	}

	.map-top-left-possition {
		position: fixed;
		top: 69px;
		left: 10px;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		z-index: 50000;
	}
}
</style>
